import { Component, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ArticlesInfosFacadeService } from "../../services/article-infos/article-infos-facade.service";
import { StatsArticleComponent } from "../stats-article/stats-article.component";

@Component({
  selector: "vl-stats-article-dialog",
  standalone: true,
  imports: [StatsArticleComponent],
  templateUrl: "./stats-article-dialog.component.html",
  styleUrl: "./stats-article-dialog.component.scss",
})
export class StatsArticleDialogComponent {
  dialogRef = inject(MatDialogRef<StatsArticleDialogComponent>);
  data = inject(MAT_DIALOG_DATA);
  aiFacade = inject(ArticlesInfosFacadeService);

  articleInfos = this.aiFacade.getByArticleId(this.data.articleId);
}
